import { useCallback } from 'react';
import { branchesService } from '../services';
import {
  useResourceCollection,
  useResourceById,
  useCreateResource,
  useUpdateResource,
  useDeleteResource,
  ResourceState,
  SingleResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { Branch } from '../types';

export function useBranches(
  options?: ResourceQueryOptions
): ResourceState<Branch> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      branchesService.getAll(opts) as unknown as Promise<{ data: Branch[]; meta?: any }>,
    []
  );
  return useResourceCollection<Branch>(fetchFn, options);
}

export function useBranch(
  id: string | null,
  options?: ResourceQueryOptions
): SingleResourceState<Branch> {
  const resourceId = id;
  const fetchFn = useCallback(
    (branchId: string | number, opts?: ResourceQueryOptions) =>
      branchesService.getById(branchId, opts) as unknown as Promise<Branch>,
    []
  );
  return useResourceById<Branch>(fetchFn, resourceId, options);
}

export function useCreateBranch(
  onSuccess?: (data: Branch) => void
): MutationState<Branch> {
  const createFn = useCallback(
    (data: any) => branchesService.create(data) as unknown as Promise<Branch>,
    []
  );
  return useCreateResource<Branch>(createFn, onSuccess);
}

export function useUpdateBranch(
  onSuccess?: (data: Branch) => void
): MutationState<Branch> {
  const updateFn = useCallback(
    (id: string | number, data: any) => {
      return branchesService.update(id, data) as unknown as Promise<Branch>;
    },
    []
  );
  return useUpdateResource<Branch>(updateFn, onSuccess);
}

/**
 * Delete branch using documentId
 * @param data - Full branch object containing documentId
 */
export function useDeleteBranch(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return branchesService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
// Auto-generated hook file
